import React, { Component } from "react";
import request, { tracesDirectUrl, tracesToken } from "../../lib/requester";
import _ from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import Autocomplete from "../../component/autocomplete";
import axios from "axios";

// Component
import GeneralInfo from "../../component/generalinfo";
import CustomerInfo from "../../component/customerinfo";
import ProductList from "../../component/productlist";
import Attachments from "../../component/attachments";
import Reason from "../../component/reason";
import ClaimInfo from "../../component/claiminfo";

import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import * as Minio from "minio";

const minioClient = new Minio.Client({
    endPoint: "s3.dexagroup.com",
    accessKey: "aam-traces",
    secretKey: "BkwJ0bdaNaSPl44tzxwC01Z6nsAM!U",
});

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lovSupplierSite: [],
            lovSupplier: [],
            supplier: "",
            supplierId: 0,
            supplierSite: 0,
            orgInitital: "",
            orgId: "",
            bankName: "",
            accOwner: "",
            paidDate: new Date(),
            paidAmount: 0,
            status: "",
            paymentMethod: "",
            norek: "",
            npwp: "",
            skb: "N",
            taxNo: "",
            taxDate: new Date(),
            fileSKB: { filename: "", path: "" },
            fileLain: { filename: "", path: "" },
            fileTambahan: { filename: "", path: "" },
            principalName: "",
            description: "",
            refNumber: "",
            programType: "",
            customerName: "",
            potongTagihan: "",
            pphRate: 1,
            pphType: "",
            dpp: 0,
            ppn: 0,
            pph: 0,
            totalAmount: 0,
            docs: [],
            fileContainer: {},
            error: [],
            listInvoice: [],
            lovPPH: [],
            success: "",
            user: JSON.parse(window.localStorage.getItem("is_user")) || {},
            submitteddate: "",
            skpnumber: "",
            programNumber: "",
            budgetType: "",
            program_budget: 0,
            assign_budget: 0,
            sales_target: 0,
            claimnumber: "",
            claimNumber:'',
            createdbyID: "",
            createdby: "",
            kwitansino: "",
            docsContainer: [],
            general_claim_number: "",
            general_skp_number: "",
            general_program_number: "",
            general_principal: "",
            general_reff_number: "",
            general_program_type: "",
            general_description: "",
            general_program_submitted_date: "",
            general_program_start_date: "",
            general_program_end_date: "",
            general_claim_exp_date: "",
            general_budget_type: "",
            general_budget: "",
            general_budget_assigned: "",
            general_sales_target: "",
            general_customer_pph_type: "",
            general_customer_pph_rate: "",
            customer_name: "",
            customer_npwp_no: "",
            customer_npwp_address: "",
            customer_npwp_name: "",

            // new
            newBupotFile: "",
            newClaimId: "",
            newFileName: "",
        };
    }

    componentDidMount = () => {
        this.getDetailProgram();
        this.getPPhType();
    };

    setGeneralInfo = (header) => {
        this.setState({
            general_claim_number: header.claim_number,
            general_skp_number: header.skp_number,
            general_program_number: header.program_number,
            general_principal: header.org_name,
            general_reff_number: header.ref_number,
            general_program_type: header.program_name,
            general_description: header.description,
            general_program_submitted_date: moment(header.creation_date).format(
                "DD-MMM-YYYY"
            ),
            general_program_start_date: moment(header.start_date).format(
                "DD-MMM-YYYY"
            ),
            general_program_end_date: moment(header.end_date).format("DD-MMM-YYYY"),
            general_claim_exp_date: moment(header.claim_exp_date).format(
                "DD-MMM-YYYY"
            ),
            general_budget_type: header.budget_type,
            general_budget: header.program_budget,
            general_budget_assigned: header.assign_budget,
            general_sales_target: header.sales_target,
            general_customer_pph_type: header.pph_type,
            general_customer_pph_rate: header.pph_rate,
        });
    };

    setCustomerInfo = (customer) => {
        this.setState({
            customer_npwp_name: customer.name,
            customer_npwp_address: customer.address,
            customer_npwp_no: customer.npwp,
        });
    };

    getPPhType = () => {
        let url = "/api/traces/v1/general/pph-type";
        request.getTraces(url, {
            success: function (response) {
                this.setState({ lovPPH: response.data.data });
            }.bind(this),
            error: function (e) {
                console.log(e);
            },
        });
    };

    renderLovPPh = () => {
        return (
            <select
                disabled
                className="form-control"
                name="pphType"
                value={this.state.pphType}
                onChange={this.handleChangeInput.bind(this)}
            >
                <option>- Select Type -</option>
                {this.state.lovPPH.map((item, index) => (
                    <option value={item.pph_type} key={index}>
                        {item.pph_type}
                    </option>
                ))}
            </select>
        );
    };

    getDetailProgram = () => {
        let url = "/api/traces/v1/claim/detail-by-claimid";
        let { id } = this.props.match.params;
        let param = {
            claim_id: id,
        };
        this.setState({ loading: true });
        request.postTraces(url, param, {
            success: function (response) {
                let { header, claim, attachment, invoice, document } =
                    response.data.data;
                if (claim.doc_mandatory_filename) {
                    attachment.push({
                        document_name: "",
                        path: claim.doc_mandatory_path || "",
                        filename: claim.doc_mandatory_filename || "",
                        key: claim.doc_mandatory_file_key,
                        claim_id: claim.claim_id,
                        doc: 'mandatory',
                        claim_number: header.claim_number
                    });
                }
                if (claim.doc_tambahan_filename) {
                    attachment.push({
                        document_name: "Additional Document",
                        path: claim.doc_tambahan_path || "",
                        filename: claim.doc_tambahan_filename || "",
                        key: claim.doc_mandatory_file_key,
                        claim_id: claim.claim_id,
                        doc: 'aditional'
                    });
                    document.push({
                        document_name: "Additional Document",
                        path: claim.doc_tambahan_path || "",
                        filename: claim.doc_tambahan_filename || "",
                        key: claim.doc_mandatory_file_key,
                        claim_id: claim.claim_id,
                        doc: 'aditional'
                    });
                }
                let newDocs = document;
                let newAttach = attachment;

                this.setGeneralInfo(header);

                this.setState({
                    newClaimId: claim.claim_id,
                    newFileName: claim.doc_bupot_filename,
                    claimnumber: header.claim_number,
                    claimNumber: header.claim_number,
                    programNumber: header.program_number,
                    budgetType: header.budget_type,
                    skpnumber: header.skp_number,
                    sisabudget: header.sisa_budget,
                    program_budget: header.program_budget,
                    assign_budget: header.assign_budget,
                    sales_target: header.sales_target,
                    orgId: header.org_id,
                    orgInitial: header.org_initial,
                    supplier: claim.aam_vendor_name,
                    supplierId: claim.aam_vendor_id,
                    supplierSite: claim.aam_vendor_site_id,
                    loading: false,
                    bankName: claim.bank || "",
                    accOwner: claim.bank_acc_owner || "",
                    principalName: header.org_name,
                    refNumber: header.ref_number,
                    programType: header.program_name,
                    description: header.description,
                    customerName: header.customer_name || "",
                    dpp: this.thousandSeparator(claim.dpp || 0),
                    ppn: this.thousandSeparator(claim.ppn || 0),
                    pphRate: claim.pph_rate,
                    pphType: claim.pph_type,
                    potongTagihan: claim.potong_tagihan,
                    docs: newAttach,
                    docsContainer: newDocs,
                    listInvoice: invoice,
                    submitteddate: moment(header.creation_date).format("DD-MMM-YYYY"),
                    claimExpDate: moment(header.claim_exp_date).format("DD-MMM-YYYY"),
                    startDate: moment(header.start_date).format("DD-MMM-YYYY"),
                    endDate: moment(header.end_date).format("DD-MMM-YYYY"),
                    createdbyID: header.created_by,
                    paymentMethod: claim.payment_method,
                    npwp: claim.npwp,
                    norek: claim.no_rekening,
                    skb: claim.skb,
                    taxNo: claim.tax_no,
                    status: claim.status,
                    taxDate: moment(claim.tax_date).format("DD-MMM-YYYY"),
                    fileSKB: {
                        filename: claim.doc_skb_filename,
                        path: claim.doc_skb_path,
                    },
                    fileLain: {
                        filename: claim.doc_lain_filename,
                        path: claim.doc_lain_path,
                    },
                    fileTambahan: {
                        filename: claim.doc_tambahan_filename,
                        path: claim.doc_tambahan_path,
                    },
                    kwitansino: header.cust_receipt_no,
                });
                this.getSupplierSite(claim.aam_vendor_id);
                this.handleGetCreatedBy(header.created_by);
                console.log(this.state.createdby);
                let app = this;
                window.setTimeout(() => {
                    app.calculateAmount();
                }, 200);
            }.bind(this),
            error: function (e) {
                console.log(e);
                this.setState({ loading: false });
            }.bind(this),
        });
    };

    showError = () => {
        if (this.state.error.length > 0) {
            return (
                <div className="alert alert-danger" role="alert">
                    <ul>
                        {this.state.error.map((item, index) => {
                            return <li key={index}>{item}</li>;
                        })}
                    </ul>
                </div>
            );
        }
    };

    showSuccess = () => {
        if (this.state.success.length > 0) {
            return (
                <div className="alert alert-success" role="alert">
                    <i className="fas fa-check"></i> {this.state.success}
                </div>
            );
        }
    };

    thousandSeparator = (value) => {
        value = value.toString();
        value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
        var parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    };

    removeSeparator = (value) => {
        value = value.toString();
        return value.replace(/,/g, "");
    };

    calculateAmount = () => {
        let { dpp, ppn, pph, totalAmount } = this.state;
        totalAmount =
            (parseInt(this.removeSeparator(dpp)) || 0) -
            (parseInt(this.removeSeparator(pph)) || 0) +
            (parseInt(this.removeSeparator(ppn)) || 0);
        let app = this;
        window.setTimeout(() => {
            app.setState({
                totalAmount: this.thousandSeparator(totalAmount),
                ppn: this.thousandSeparator(ppn),
                paidAmount: this.thousandSeparator(totalAmount),
            });
        }, 500);
    };

    handleChangeInput = (event) => {
        let value = event.target.value;
        let name = event.target.name;

        if (name === "pph" || name === "ppn" || name === "dpp") {
            value = this.thousandSeparator(value);
        } else if (name === "paidAmount") {
            value = this.thousandSeparator(value.replace(/[^\d]/, ""));
        }

        this.setState({ [name]: value });
        if (name === "pph" || name === "ppn" || name === "dpp") {
            let app = this;
            window.setTimeout(() => {
                app.calculateAmount();
                app.forceUpdate();
            }, 100);
        }
    };

    renderDocument = () => {
        return this.state.docs.map((item, index) => (
            <div className="row border-bottom" key={index}>
                <div className="col-md-2 mt-2">{item.document_name}</div>
                <div className="col-md-6 mt-2">
                    <Link to={{ pathname: item.path }} target="_blank">
                        {item.filename}
                    </Link>
                </div>
            </div>
        ));
    };

    downloadAttachment = (data, preview) => {
        this.setState({ loading: true });
        let url = data.doc === 'bupot' ?
            `/api/traces/v1/tracking-email/download-surat-refund?bupot_file_key=${data.key}&bupot_filename=${data.filename}` :
            data.doc === 'mandatory' ?
                `/api/traces/v1/tracking-email/download-surat-refund?mandatory_filename=${data.filename}&mandatory_file_key=${data.key}` :
                `/api/traces/v1/tracking-email/download-surat-refund?additional_FileName=${data.filename}&mandatory_file_key=${data.key}`

        request.getTraces(url, {
            success: function (response) {
                if (response.data.statusCode === 400) {
                    window.open(data.path, "_blank");
                    this.setState({ loading: false });
                } else {
                    axios({
                        url: response.config.url,
                        method: 'GET',
                        responseType: 'blob',
                        headers: {
                            Authorization: `Bearer ${tracesToken()}`,
                        },
                    }).then((response) => {
                        if (preview && preview === 'preview') {
                            const objectUrl = URL.createObjectURL(response.data)
                            const pdfWindow = window.open();
                            pdfWindow.location.href = objectUrl;
                            // window.open(response.config.url, "_blank");
                            this.setState({ loading: false });
                        } else {
                            const href = URL.createObjectURL(response.data);
                            const link = document.createElement('a');
                            link.href = href;
                            link.setAttribute('download', data.doc === "bupot" ? `CLAIM_${data.claim_id}.pdf` : data.doc === "mandatory" ? `${data.claim_number.replace(/[/]/g, '')}.pdf` : `${data.filename}.pdf`);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(href);
                            this.setState({ loading: false });
                        }
                    })
                        .catch(error => {
                            window.open(data.path, "_blank");
                            this.setState({ loading: false });
                        })
                }
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false });
            }.bind(this),
        });
    }

    renderUploadedFile = (index) => {
        let { fileContainer } = this.state;
        let find = _.find(fileContainer, function (o) {
            return parseInt(o.index) === parseInt(index);
        });
        if (find) {
            return (
                <span>
                    <Link to={{ pathname: find.path }} target="_blank">
                        {find.filename}{" "}
                    </Link>
                    &nbsp;
                    <button
                        type="button"
                        className="btn btn-danger"
                        data-index={index}
                        onClick={() => {
                            this.removeFile(index);
                        }}
                    >
                        <i className="fas fa-trash-alt"></i>
                    </button>
                </span>
            );
        }
    };

    removeFile = (index) => {
        let indexing = _.findIndex(this.state.fileContainer, function (o) {
            return parseInt(o.index) === parseInt(index);
        });
        if (indexing >= 0) {
            let container = this.state.fileContainer;
            container.splice(indexing, 1);
            this.setState(container);
        }
    };

    validateForm = () => {
        let { newBupotFile } = this.state;
        let error = [];
        if (!newBupotFile.file || newBupotFile.fileList.length === 0) {
            error.push("File e-bupot is required");
        }

        if (error.length > 0) {
            window.scrollTo(0, 0);
            this.setState({ error: error });
            return false;
        } else {
            return true;
        }
    };

    renderTableInvoice = () => {
        if (this.state.paymentMethod === "INV") {
            return (
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Invoice Number</th>
                            <th>Invoice Amount</th>
                            <th>Invoice Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.listInvoice.map((item, index) => (
                            <tr key="index">
                                <td>{item.invoice_number}</td>
                                <td>{item.invoice_amount}</td>
                                <td>
                                    {moment(new Date(item.invoice_date)).format("DD-MMM-YYYY")}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }
    };

    // renderNorek = () => {
    //     if (this.state.paymentMethod === "TRF") {
    //         // if (this.state.orgInitial === 'AAM') {
    //         if (1 === 1) {
    //             return (
    //                 <div>
    //                     <div className="form-group row">
    //                         <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
    //                             Supplier
    //                         </label>
    //                         <div className="col-sm-8">
    //                             <Autocomplete
    //                                 onchange={this.onChangeAutocomplete.bind(this)}
    //                                 isDisabled={this.state.supplier.length > 0 ? true : false}
    //                                 currentvalue={this.state.supplier}
    //                                 currentIndex={0}
    //                                 principalCode={this.state.user.orgInitial}
    //                                 onselect={this.onSelectSupplier.bind(this)}
    //                             />
    //                         </div>
    //                     </div>
    //                     <div className="form-group row">
    //                         <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
    //                             Supplier Site
    //                         </label>
    //                         <div className="col-sm-8">
    //                             <select
    //                                 disabled
    //                                 className="form-control"
    //                                 value={this.state.supplierSite}
    //                                 name="supplierSite"
    //                                 onChange={this.handleChangeInput.bind(this)}
    //                             >
    //                                 <option value="">- Select Supplier Site -</option>
    //                                 {this.state.lovSupplierSite.map((item, index) => (
    //                                     <option value={item.SUPPLIER_SITE_ID}>
    //                                         {item.SUPPLIER_SITE_CODE}
    //                                     </option>
    //                                 ))}
    //                             </select>
    //                         </div>
    //                     </div>
    //                 </div>
    //             );
    //         } else {
    //             return (
    //                 <div>
    //                     <div className="form-group row">
    //                         <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
    //                             Account No
    //                         </label>
    //                         <div className="col-sm-8">
    //                             <input
    //                                 type="text"
    //                                 disabled
    //                                 autoComplete="off"
    //                                 className="form-control"
    //                                 id="inputEmail3"
    //                                 name="norek"
    //                                 placeholder="No Rekening"
    //                                 onChange={this.handleChangeInput.bind(this)}
    //                                 value={this.state.norek}
    //                             />
    //                         </div>
    //                     </div>
    //                     <div className="form-group row">
    //                         <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
    //                             Bank Name
    //                         </label>
    //                         <div className="col-sm-8">
    //                             <input
    //                                 type="text"
    //                                 disabled
    //                                 autoComplete="off"
    //                                 className="form-control"
    //                                 id="inputEmail3"
    //                                 name="norek"
    //                                 placeholder="Bank Name"
    //                                 onChange={this.handleChangeInput.bind(this)}
    //                                 value={this.state.bankName}
    //                             />
    //                         </div>
    //                     </div>
    //                     <div className="form-group row">
    //                         <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
    //                             Account Owner
    //                         </label>
    //                         <div className="col-sm-8">
    //                             <input
    //                                 type="text"
    //                                 disabled
    //                                 autoComplete="off"
    //                                 className="form-control"
    //                                 id="inputEmail3"
    //                                 name="norek"
    //                                 placeholder="Account Owner"
    //                                 onChange={this.handleChangeInput.bind(this)}
    //                                 value={this.state.accOwner}
    //                             />
    //                         </div>
    //                     </div>
    //                 </div>
    //             );
    //         }
    //     }
    // };

    renderTax = () => {
        let { ppn } = this.state;
        if (parseInt(this.removeSeparator(ppn)) > 0) {
            return (
                <div>
                    <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                            Tax No
                        </label>
                        <div className="col-sm-8">
                            <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="taxNo"
                                placeholder="Tax No"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.taxNo}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                            Tax Date
                        </label>
                        <div className="col-sm-8">
                            <input
                                type="text"
                                disabled
                                className="form-control"
                                value={this.state.taxDate}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };
    handleRedirect = (e) => {
        e.preventDefault()
        const url = request.getFileS3('skb', this.state.fileContainer.filename);
        if (url && url.length > 0) {
            window.open(url, '_blank');
        }
    };

    renderSKBAttachment = () => {
        if (this.state.skb === "Y") {
            return (
                <a
                    href="#"
                    onClick={this.handleRedirect.bind(this)}
                    target="blank"
                    rel="noopener noreferrer"
                >
                    {this.state.fileSKB.filename}
                </a>
            );
        }
    };

    handleApprove = () => {
        let url = "/api/v1/claim/approve-principal";
        let { id } = this.props.match.params;
        let param = {
            claim_id: id,
            status: "A",
        };
        this.setState({ loading: true });
        request.post(url, param, {
            success: function (response) {
                this.setState({ loading: false, success: "Claim has been approved" });
                window.scrollTo(0, 0);
                let app = this;
                window.setTimeout(() => {
                    app.props.history.push("/admin/claim/approval");
                }, 2000);
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false });
            }.bind(this),
        });
    };

    handleReject = () => {
        let url = "/api/v1/claim/approve-principal";
        let { id } = this.props.match.params;
        let param = {
            claim_id: id,
            status: "R",
        };
        this.setState({ loading: true });
        request.post(url, param, {
            success: function (response) {
                this.setState({ loading: false, success: "Claim has been rejected" });
                window.scrollTo(0, 0);
                let app = this;
                window.setTimeout(() => {
                    app.props.history.push("/admin/claim/approval");
                }, 2000);
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false });
            }.bind(this),
        });
    };

    mappingBadge = (status) => {
        let label = "";
        let classname = "";
        switch (status) {
            case "A":
                label = "APPROVE";
                classname = "badge badge-success";
                break;
            case "P":
                label = "PROPOSE";
                classname = "badge badge-info";
                break;
            case "R":
                label = "REJECT";
                classname = "badge badge-danger";
                break;
            default:
                label = "PROPOSE";
                classname = "badge badge-info";
                break;
        }
        return {
            label: label,
            class: classname,
        };
    };

    handlePaidDate = (date) => {
        this.setState({ paidDate: date });
    };

    handlePaid = () => {
        if (
            parseInt(this.state.paidAmount) === 0 ||
            this.state.paidAmount.length === 0
        ) {
            this.setState({ error: ["Paid amount is empty"] });
            window.scrollTo(0, 0);
            return false;
        }
        let url = "/api/v1/program/insert-payment";
        let { id } = this.props.match.params;
        let param = {
            paidDate: moment(this.state.paidDate).format("YYYY-MM-DD HH:mm:ss"),
            paidAmount: this.removeSeparator(this.state.paidAmount),
            claimId: id,
        };
        this.setState({ loading: true });
        request.post(url, param, {
            success: function (response) {
                this.setState({
                    loading: false,
                    success: "Payment has been saved successfully",
                });
                window.scrollTo(0, 0);
                let app = this;
                window.setTimeout(() => {
                    app.props.history.push("/payment");
                }, 2000);
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false, error: ["Failed to save payment"] });
            }.bind(this),
        });
    };

    handleUpload = (e) => {
        if (e.target.files.length === 0) {
            return false;
        }

        let files = e.target.files[0];
        // validation
        let filename = files.name;
        var fileExt = filename.split(".").pop();
        var allowedFile = [
            "jpg",
            "png",
            "jpeg",
            "gif",
            "doc",
            "docx",
            "xls",
            "xlsx",
            "csv",
            "pdf",
        ];
        if (allowedFile.indexOf(fileExt) < 0) {
            this.setState({ error: ["File extension not allowed"] });
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            return false;
        }

        const data = new FormData();
        data.append("myFile", files, files.name);
        this.setState({ loading: true });
        request.postnobodyTraces("/api/traces/v1/general/upload-file", data, {
            success: function (response) {
                let data = response.data;
                this.setState({ fileContainer: data, loading: false });
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false });
            },
        });
    };

    removeFileBupot = () => {
        this.setState({ fileContainer: {} });
    };

    renderFileBupot = () => {
        if (this.state.fileContainer && this.state.fileContainer.filename) {
            return (
                <span>
                    <Link
                        to={{ pathname: this.state.fileContainer.path }}
                        target="_blank"
                    >
                        {this.state.fileContainer.filename}
                    </Link>
                    &nbsp;
                    <button
                        className="btn btn-danger"
                        onClick={this.removeFileBupot.bind(this)}
                    >
                        <i className="fas fa-trash-alt"></i>
                    </button>
                </span>
            );
        }
    };

    handleSubmit = async () => {
        if (this.validateForm()) {
            this.setState({ loading: true });
            let url = "/api/traces/v1/claim/upload-bupot-flag";
            const file = this.state.newBupotFile.file;

            const presignedUrl = async (fileName) => {
                try {
                    const policy = minioClient.newPostPolicy();
                    policy.setKey(fileName);
                    policy.setBucket("aam-traces");

                    const expires = new Date();
                    expires.setSeconds(24 * 60 * 60 * 10); // 10 days expiry.
                    policy.setExpires(expires);
                    return await minioClient.presignedPostPolicy(policy);
                } catch (error) {
                    console.log(error);
                }
            };

            const uploadToS3 = async (obj, file) => {
                try {
                    const formData = new FormData();
                    Object.entries(obj.formData).forEach(([key, value]) => {
                        formData.append(key, value);
                    });
                    formData.append("file", file.originFileObj);

                    return await axios.post(obj.postURL, formData);
                } catch (error) {
                    console.log("upload s3 : ", error);
                }
            };

            const param = {
                CLAIM_NUMBER: this.state.claimnumber,
                STATUS: "F",
            };

            await request.putTraces(url, param, {
                success: function (response) {
                    const res = response.data;
                },
                error: function (e) {
                    console.log(e);
                },
            });

            try {
                let claim_no = this.state.claimnumber.split("-");
                const fileName = `/bukti-potong/CLAIM_${claim_no[1]}.pdf`;
                const minioUrl = await presignedUrl(fileName);
                const uploadFilePdf = await uploadToS3(minioUrl, file);

                if (uploadFilePdf?.status === 204) {
                    const paramUpdate = {
                        CLAIM_NUMBER: this.state.claimnumber,
                        FILENAME: this.state.newBupotFile.file.name.replace(/:/g, "/"),
                        STATUS: "S",
                        SOURCE: "infostep",
                    };
                    await request.putTraces(url, paramUpdate, {
                        success: function (response) {
                            this.setState({ loading: false, success: "File has been saved" });
                            window.scrollTo(0, 0);
                            let app = this;
                            window.setTimeout(() => {
                                app.props.history.push("/admin/claim/upload");
                            }, 2000);
                        }.bind(this),
                        error: function (e) {
                            this.setState({ loading: false, error: ["Failed to upload"] });
                        }.bind(this),
                    });
                }
            } catch (error) {
                this.setState({ loading: false, error: ["Failed to submit"] });
            }
        }
    };

    handleGetCreatedBy = (user_id) => {
        this.setState({ loading: true });

        let url = "/api/arman/v1/general/get-username";
        let param = {
            user_id: user_id,
        };

        request.postArman(url, param, {
            success: function (response) {
                let { data } = response.data;
                console.log(data.username);
                this.setState({
                    createdby: data.username,
                    loading: false,
                });
                window.scrollTo(0, 0);
                let app = this;
                window.setTimeout(() => {
                    // app.props.history.push('/admin/claim/upload')
                }, 2000);
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false });
            }.bind(this),
        });
    };

    handleSendEmail = () => {
        if (this.validateForm()) {
            let url = "/api/traces/v1/claim/send-email-bupot";
            let { id } = this.props.match.params;
            let param = {
                claim_id: id,
                claim_number: this.state.claimnumber,
                fileContainer: this.state.fileContainer,
                principal: this.state.principalName,
                username: this.state.user.username,
                sendto: this.state.createdby,
            };
            this.setState({ loading: true });
            request.postTraces(url, param, {
                success: function (response) {
                    this.setState({ loading: false });
                    window.scrollTo(0, 0);
                    let app = this;
                    window.setTimeout(() => {
                        // app.props.history.push('/admin/claim/upload')
                    }, 2000);
                }.bind(this),
                error: function (e) {
                    this.setState({ loading: false });
                }.bind(this),
            });
        }
    };

    onChangeAutocomplete = (q) => {
        let url = request.getOracle()
        console.log("url : ", url)
        let param = {
            supplier_name: q,
        };
        return new Promise((resolve, reject) => {
            axios
                .post(url, param)
                .then((response) => {
                    let { data } = response.data;
                    let lovSupplier = [];
                    data.forEach((item, index) => {
                        // [0] supplier name [1] supplier id
                        lovSupplier.push({ text: item[0], value: item[1] });
                    });
                    resolve(lovSupplier);
                })
                .catch((e) => {
                    reject(e);
                });
        });
    };

    onSelectSupplier = (item, index) => {
        this.setState({ supplier: item.text, supplierId: item.value });
        this.getSupplierSite(item.value);
    };

    getSupplierSite = (id) => {
        if (!id || id.length === 0) {
            return false;
        }
        let url = "/api/v1/oracle/supplier-site";
        let param = { supplier_id: id };
        this.setState({ loading: true });
        request.postOracle(url, param, {
            success: function (response) {
                let { data } = response.data;
                let lovSupplierSite = [];
                data.forEach((item, index) => {
                    lovSupplierSite.push({
                        SUPPLIER_SITE_CODE: item[0],
                        SUPPLIER_SITE_ID: item[1],
                    });
                });
                this.setState({ lovSupplierSite: lovSupplierSite, loading: false });
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false });
            }.bind(this),
        });
    };

    renderUploadEbupot = () => {
        return (
            <div className="card">
                <div className="card-header font-size-title bg-light font-weight-bold">
                    Upload E-Bupot
                </div>
                <div className="card-body">
                    <div className="row" id="paymentInfo">
                        <div className="col-md-12">
                            <div className="form-group row">
                                <label htmlFor="inputEmail3" className="mr-5 col-form-label">
                                    Upload File:
                                </label>
                                <div className="mt-2">
                                    <Upload
                                        name="xlsx"
                                        multiple={false}
                                        customRequest={() => false}
                                        onChange={(info) => {
                                            this.setState({
                                                newBupotFile: info,
                                            });
                                            this.setState({ error: "" });
                                        }}
                                        showUploadList={false}
                                    >
                                        <Button icon={<UploadOutlined />}>Upload (Max: 1)</Button>
                                    </Upload>
                                    <p className=" mt-2 text-gray">
                                        {this.state.newBupotFile
                                            ? this.state.newBupotFile.file.name.replace(/:/g, "/")
                                            : ""}
                                    </p>
                                    {this.state.newFileName ? (
                                        <Link
                                            className="mt-2"
                                            to={{
                                                pathname: `${tracesDirectUrl()}/api/traces/v1/general/s3/download-file?path=bukti-potong&filename=CLAIM_${this.state.newClaimId
                                                    }.pdf`,
                                            }}
                                            target="_blank"
                                        >
                                            <span className="text-gray">Uploaded File : </span>
                                            {`CLAIM_${this.state.newClaimId}.pdf`}
                                        </Link>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">{this.renderFileBupot()}</div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row ml-1">
                            <div className="col-lg-12 col-sx-12">
                                <div className="card card-info">
                                    <div className="card-body">
                                        {this.showError()}
                                        {this.showSuccess()}
                                        <form className="form-horizontal">
                                            <GeneralInfo data={this.state} />
                                            <ClaimInfo data={this.state} />
                                            {this.renderUploadEbupot()}
                                            <Attachments data={this.state} />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success"
                                                        onClick={this.handleSubmit.bind(this)}
                                                    >
                                                        Submit
                                                    </button>
                                                    &nbsp;
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning"
                                                        onClick={() => {
                                                            this.props.history.push("/admin/payment");
                                                        }}
                                                    >
                                                        <i className="fas fa-arrow-left"></i> Back
                                                    </button>
                                                    &nbsp;
                                                    {/* <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={this.handleSendEmail.bind(this)}
                              >
                                SEND
                              </button> */}
                                                    &nbsp;
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Loader fullPage loading={this.state.loading} />
            </div>
        );
    }
}

export default Detail;
